import "./App.css";
import { RenderRoutes } from "./Router/RenderRoutes";
import { Amplify } from "aws-amplify";
import { CustomTheme } from "ThemeCustom";
import { ConfigProvider } from "antd";
import { useEffect } from "react";
import { getAccountDetails } from "Sdk/Actions";
import { useSelector } from "react-redux";
import {
  getTokenFromReducer,
  getUserNameFromReducer,
} from "Store/reducers/Auth/AuthSlice";
import awsExports from "./aws-exports";

Amplify.configure(awsExports);

function App() {
  const config = awsExports;
  Amplify.configure(config);

  const userName = useSelector(getUserNameFromReducer);
  const token = useSelector(getTokenFromReducer);

  useEffect(() => {
    const fetchUserDetails = async () => {
      await getAccountDetails(userName);
    };
    if (token) {
      fetchUserDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfigProvider theme={CustomTheme}>
      <RenderRoutes />
    </ConfigProvider>
  );
}

export default App;
